import dayjs from 'dayjs';

export function getNthWeekdayOfMonth(year: number, month: number, weekday: number, occurrence: number) {
  const date = dayjs().year(year).month(month).date(1);
  const firstDayWeekday = date.day();

  let offset = weekday - firstDayWeekday;

  if (offset < 0) {
    offset += 7;
  }

  const firstOccurrence = date.add(offset, 'day');
  const nthOccurrence = firstOccurrence.add((occurrence - 1) * 7, 'day');

  if (nthOccurrence.month() !== month) {
    return null;
  }

  return nthOccurrence.toDate();
}
